<app-ip-title-mobile
    [title]="'IP.SIDENAV.OPTIONS.PAY_INVOICES' | translate" ></app-ip-title-mobile>
<div class="fn-pay-invoices">
  <div class="fn-pay-invoices__btn">
    <!-- <button
      *ngIf="stepper.selectedIndex === 0"
      class="fn-pay-invoices__btn-process"
      (click)="goToStep(1, stepper)"
      matTooltip="Procesar"
      matTooltipPosition="above"
    >
      <img
        src="../../../../../../assets/new-styles/icons/buttons/right-circle-arrow.svg"
        alt=""
      />
    </button> -->
    <!-- <button
      *ngIf="stepper.selectedIndex === 1"
      class="fn-pay-invoices__btn-process"
      (click)="openConfirmDialog(confirmDialog, 2, stepper)"
    >
      <span>Generar consolidado</span>
      <img
        src="../../../../../../assets/new-styles/icons/buttons/right-circle-arrow.svg"
        alt=""
      />
    </button> -->
  </div>
  <mat-stepper [linear]="true" #stepper [animationDuration]="'0'" [orientation]="mobile ? 'vertical' : 'horizontal'">
    <ng-template matStepperIcon="edit">
      <mat-icon style="color: white;">done</mat-icon>
    </ng-template>
    <mat-step
      [stepControl]="firstFormGroup"
      [completed]="isStepCompleted(0)"
      [editable]="isEditable(0,stepper)"
    >
    <ng-template matStepLabel>
      <div class="fn-pay-invoices__step-title" (click)="returnToStep()">
        <span>{{ 'IP.PAY-INVOICES.STEP-1' | translate }}</span>
        <app-ip-button-modal
        *ngIf="stepper.selectedIndex === 0"
        (clicked)="goToStep($event, 1, stepper)"
        [typeBtn]="'submit'"
        [size]="'small'"
        matTooltip="Procesar"
        matTooltipPosition="above"
        [disabled]="!selectedInvoicesList || selectedInvoicesList.length === 0"
        >
        <img
        src="./assets/icons/right-circle-arrow.svg"
        alt=""
        />
        </app-ip-button-modal>
      </div>
    </ng-template>
      <div class="fn-pay-invoices__container-invoices">
        <div class="fn-pay-invoices__container-invoices__table">
          <app-fn-tables
            [optionalTitle]="'IP.TABLE.PAY-INVOICES.TITLE'"
            [tableOption]="tableOptions"
            [propertyOrder]="propertyOrder"
            (action)="onAction($event)"
            [pageItems]="10"
            [filter]="false"
            (invoicesSelected)="onInvoiceSelectionChange($event)"
            service="invoice-to-pay"
            [isForSelectedItem]="true"
            [searchField]="false"
          />
        </div> 
      </div>
    </mat-step>
    <mat-step
      [stepControl]="secondFormGroup"
      [completed]="isStepCompleted(1)"
      [editable]="isEditable(1,stepper)"
    >
      <ng-template matStepLabel>
      <div class="fn-pay-invoices__step-title">
        <span>{{ 'IP.PAY-INVOICES.STEP-2' | translate }}</span>
        <app-ip-button-modal
        *ngIf="stepper.selectedIndex === 1"
        [typeBtn]="'submit'"
        [size]="'small'"
        (clicked)="openConfirmDialog($event, confirmDialog, 2, stepper)"
        matTooltip="Generar consolidado"
        matTooltipPosition="above"
        >
        <img
        src="./assets/icons/right-circle-arrow.svg"
        alt=""
        />
        </app-ip-button-modal>
      </div>
    </ng-template>
      <div class="fn-pay-invoices__container-invoices">
        <div
          class="fn-pay-invoices__container-invoices__table"
          *ngIf="totalsConsolidated"
        >
          <app-fn-tables
            [optionalTitle]="'IP.TABLE.CONSOLIDATED.TITLE'"
            [tableOption]="tableOptionsConsolidated"
            [propertyOrder]="propertyOrderSelectedItems"
            (action)="onAction($event)"
            [pageItems]="10"
            [filter]="false"
            [totalsForConsolidated]="totalsConsolidated"
            [service]="'consolidated-template'"
            [consolidatedStep]="true"
            [searchField]="false"
          />
        </div>
      </div>
    </mat-step>
    <mat-step
      [stepControl]="secondFormGroup"
    >
    <ng-template matStepLabel>
      <div class="fn-pay-invoices__step-title">
        <span>{{ 'IP.PAY-INVOICES.STEP-3' | translate }}</span>
      </div>
    </ng-template>
      <div class="fn-pay-invoices__details">
        <div class="fn-pay-invoices__details__modal">
          <div class="fn-pay-invoices__details-group">
            <div class="fn-pay-invoices__details-group-key">
              {{ "IP.PAY-INVOICES.DETAILS.TOTAL_PROVIDERS" | translate }}
            </div>
            <div class="fn-pay-invoices__details-group-value">
              {{ consolidatedDetails?.totalSuppliers }}
            </div>
          </div>
          <div class="fn-pay-invoices__details-group">
            <div class="fn-pay-invoices__details-group-key">
              {{ "IP.PAY-INVOICES.DETAILS.TOTAL_INVOICES" | translate }}
            </div>
            <div class="fn-pay-invoices__details-group-value">
              {{ consolidatedDetails?.totalInvoices }}
            </div>
          </div>
          <div class="fn-pay-invoices__details-group">
            <div class="fn-pay-invoices__details-group-key">
              {{ "IP.PAY-INVOICES.DETAILS.TOTAL_AMOUNT" | translate }}
            </div>
            <div class="fn-pay-invoices__details-group-value">
              ${{ consolidatedDetails?.totalDue | amount }}
            </div>
          </div>
          <div class="fn-pay-invoices__details-group">
            <div class="fn-pay-invoices__details-group-key">
              {{ "IP.PAY-INVOICES.DETAILS.CONSOLIDATED_NAME" | translate }}
            </div>
            <div class="fn-pay-invoices__details-group-value">
              {{ consolidatedDetails?.consolidatedName }}
            </div>
          </div>
          <div class="fn-pay-invoices__details-group">
            <div class="fn-pay-invoices__details-group-key">
              {{ "IP.PAY-INVOICES.DETAILS.ID_CONSOLIDATED" | translate }}
            </div>
            <div class="fn-pay-invoices__details-group-value">
              {{ consolidatedDetails?.consolidatedId }}
            </div>
          </div>
          <div class="fn-pay-invoices__details-group">
            <div class="fn-pay-invoices__details-group-key">
              {{ "IP.PAY-INVOICES.DETAILS.DATETIME_CONSOLIDATED" | translate }}
            </div>
            <div class="fn-pay-invoices__details-group-value">
              {{ consolidatedDetails?.generationDate | customDate: true }}
            </div>
          </div>
          <div class="fn-pay-invoices__details__modal-btn">
            <app-ip-button-modal
              [typeBtn]="'action'"
              (clicked)="downloadCsv(consolidatedDetails?.consolidatedId)"
            >
              <div>
                <img
                  src="./assets/icons/download-icon.svg" 
                  alt=""
                  class="img-filter"
                />
                {{
                  "IP.PAY-INVOICES.DETAILS.DOWNLOAD_FOR_PAYMENTS" | translate
                }}
              </div>
            </app-ip-button-modal>
            <app-ip-button-modal
              [typeBtn]="'action'"
              (clicked)="goOut()"
            >
              {{"IP.GO_OUT" | translate}}
            </app-ip-button-modal>
          </div>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</div>

<ng-template #confirmDialog>
  <app-ip-modal-mobile [showCloseModal]="false" [showTitle]="false"> 
  <div class="fn-pay-invoices-modal">
    <div class="fn-pay-invoices-modal__header">
      <div class="fn-pay-invoices-modal__title">Generar consolidado</div>
    </div>
    <div class="fn-pay-invoices-modal__content">
      ¿Desea generar el consolidado seleccionado?
    </div>
    <app-ip-input
      type="text"
      [control]="consolidatedName"
      [label]="'Nombre del consolidado (mínimo 5 caracteres)'"
    ></app-ip-input>

    <app-ip-date-input 
      [control]="consolidatedDueDate"
      [label]="'Fecha de venciminto'"
    />

    <div class="fn-pay-invoices-modal__btns">
      <app-ip-button-modal
          typeBtn="cancel"
          mat-dialog-close="cancel"
        >
        {{ "IP.CONFIRM-ACTION-DIALOG.CANCEL" | translate }}
        </app-ip-button-modal>
        <app-ip-button-modal
          typeBtn="action"
          [mat-dialog-close]="'confirm'"
          [disabled]="consolidatedName.value.length < 5"
        >
        {{ "IP.CONFIRM-ACTION-DIALOG.CONFIRM" | translate }}
        </app-ip-button-modal>
    </div> 
  </div>
  </app-ip-modal-mobile>
  </ng-template>

